import { FunctionComponent } from "react";


export type Props = {
  name: IconNames
};

export enum IconNames {
  CLOSE = 'close',
  MORE = 'more',
  TRASH = 'trash',
  EDIT = 'edit',
  KEY = 'key',
  EYE = 'eye',
  CLOSED_EYE = 'closed_eye',
  LOCK = 'lock',
};

export type Icons = Record<IconNames, FunctionComponent>;
